import eventsCenter from '../EventsCenter';
import { GlobalService } from 'src/app/services/global.service';

export class Button {
  label: string;
  button: Phaser.GameObjects.Shape;
  callback: Function;
  scene: Phaser.Scene;
  static buttonDown: boolean = false;
  radius: number;

  constructor(scene: Phaser.Scene, radius: number = 65) {
    this.scene = scene;
    this.radius = radius*GlobalService.zoom;
    this.button = scene.add
      .circle(
        window.innerWidth - this.radius*2,
        window.innerHeight - this.radius*2,
        this.radius,
        0x888888,
        0.5
      )
      .setDepth(3)
      .on('pointerdown', () => {
        eventsCenter.emit('actionButtonPressed');
        Button.buttonDown = true;
        this.button.setFillStyle(0x444444, 0.7);
        console.log('button down');
      }).on('pointerup', () => {
        Button.buttonDown = false;
        this.button.setFillStyle(0x888888, 0.5);
        console.log('button released');
      }).on('pointerout', () => {
        Button.buttonDown = false;
        this.button.setFillStyle(0x888888, 0.5);
        console.log('button released');
      })
    this.button.setInteractive();
    this.button.setScrollFactor(0);
  }

  // Update the position of the button for window resize events.
  public updatePosition() {
    if(this.button){
      this.button.setPosition(window.innerWidth - this.radius*2, window.innerHeight - this.radius*2);
    }
  }
}
